import { Box, Grid } from '@mui/material';
import React from 'react';
import TotalCard from '../../../components/foodCards/totalCard';
import ActiveCard from '../../../components/foodCards/activeCard';
import InactiveCard from '../../../components/foodCards/inactiveCard';
import { useAdons } from '../../../customHooks/useAdons';

const Cards = () => {
  const { activeCategories, allCategories, inActiveCategories } = useAdons();

  return (
    <>
      <Box >
        <Grid container  spacing={{ xs: 2, md:34,lg:'280px' ,xl:40}}>
          <Grid item xs={12} sm={4} md={2}>
            <TotalCard total={allCategories} thing={'Add-ons'} />
          </Grid>
          <Grid item xs={12} sm={4} md={2}>
            <ActiveCard total={activeCategories} thing={'Add-ons'} />
          </Grid>
          <Grid item xs={12} sm={4} md={2}>
            <InactiveCard total={inActiveCategories} thing={'Add-ons'} />
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default Cards;
